module.exports = __webpack_public_path__ + "img/credit.55b36683.png";